
        module.exports = __webpack_public_path__ + "assets/images/favicon.14572f08.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 196,
            height: 196,
            type: "png",
            bytes: 4405,

            toString: function() {
                return src;
            }
        };
    